/* Display Clothing Co. — theme.js */

/* ── CART API ── */
var DCC = DCC || {};

DCC.Cart = {
  get: function(cb) {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(cb)
      .catch(function(){ cb({item_count:0,items:[],total_price:0}); });
  },
  add: function(variantId, qty, cb) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id: parseInt(variantId), quantity: qty || 1}]})
    })
    .then(function(r){ return r.json(); })
    .then(function(data){ if(cb) cb(null, data); })
    .catch(function(e){ if(cb) cb(e); });
  },
  remove: function(variantId, cb) {
    var updates = {};
    updates[variantId] = 0;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({updates: updates})
    })
    .then(function(r){ return r.json(); })
    .then(function(data){ if(cb) cb(null, data); })
    .catch(function(e){ if(cb) cb(e); });
  }
};

DCC.formatMoney = function(cents) {
  return '$' + (cents / 100).toFixed(2);
};

/* ── CART DRAWER ── */
DCC.openCart = function() {
  DCC.Cart.get(function(cart) {
    DCC.renderCart(cart);
    document.getElementById('cart-drawer').classList.add('open');
    document.getElementById('cart-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  });
};

DCC.closeCart = function() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if(drawer) drawer.classList.remove('open');
  if(overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
};

DCC.renderCart = function(cart) {
  var body = document.getElementById('cart-body');
  var foot = document.getElementById('cart-foot');
  var countEl = document.getElementById('cart-count');
  if(countEl) countEl.textContent = cart.item_count;
  if(!body) return;
  if(!cart.item_count) {
    body.innerHTML = '<div class="cart-empty"><p>Empty.</p><small>Add some pieces and come back.</small></div>';
    if(foot) foot.style.display = 'none';
    return;
  }
  var html = '';
  for(var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];
    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + (item.title || '') + '" loading="lazy">'
      : '<span>' + (item.title || '').slice(0,3).toUpperCase() + '</span>';
    var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
      ? 'Size: ' + item.variant_title + ' &middot; ' : '';
    html += '<div class="cart-item">'
      + '<div class="cart-item-img">' + imgHtml + '</div>'
      + '<div class="cart-item-info">'
      + '<p class="cart-item-brand">Display Clothing Co.</p>'
      + '<p class="cart-item-name">' + (item.product_title || item.title) + '</p>'
      + '<p class="cart-item-meta">' + variantLabel + 'Qty: ' + item.quantity + '</p>'
      + '<button class="cart-item-remove" type="button" data-variant-id="' + item.variant_id + '">Remove</button>'
      + '</div>'
      + '<span class="cart-item-price">' + DCC.formatMoney(item.line_price) + '</span>'
      + '</div>';
  }
  body.innerHTML = html;
  if(foot) {
    foot.style.display = 'block';
    var totalEl = document.getElementById('cart-total');
    if(totalEl) totalEl.textContent = DCC.formatMoney(cart.total_price);
  }
  // Wire remove buttons
  body.querySelectorAll('.cart-item-remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      DCC.Cart.remove(this.dataset.variantId, function() {
        DCC.Cart.get(function(c){ DCC.renderCart(c); });
      });
    });
  });
};

DCC.addToCart = function(variantId, btn) {
  if(!variantId) { alert('Please select a size first.'); return; }
  if(btn) { btn.textContent = 'Adding\u2026'; btn.disabled = true; }
  DCC.Cart.add(variantId, 1, function(err) {
    if(err) {
      if(btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
      alert('Could not add to cart. Please try again.');
      return;
    }
    if(btn) {
      btn.textContent = 'Added!';
      setTimeout(function(){
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 1500);
    }
    DCC.openCart();
  });
};

/* ── MOBILE NAV ── */
DCC.toggleMobileNav = function() {
  var nav = document.getElementById('mobile-nav');
  var btn = document.getElementById('burger-btn');
  if(!nav) return;
  var open = nav.classList.toggle('open');
  if(btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  nav.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.body.style.overflow = open ? 'hidden' : '';
};

/* ── SEARCH ── */
DCC.toggleSearch = function() {
  var ov = document.getElementById('search-overlay');
  if(!ov) return;
  var open = ov.classList.toggle('open');
  document.body.style.overflow = open ? 'hidden' : '';
  if(open) {
    var inp = document.getElementById('search-input');
    if(inp) setTimeout(function(){ inp.focus(); }, 100);
  }
};

/* ── STICKY ATC ── */
DCC.initStickyAtc = function() {
  var atcBtn = document.getElementById('pdp-atc-btn');
  var sAtc = document.getElementById('sticky-atc');
  if(!atcBtn || !sAtc) return;
  var io = new IntersectionObserver(function(entries) {
    sAtc.classList.toggle('show', !entries[0].isIntersecting);
  }, { threshold: 0 });
  io.observe(atcBtn);

  var satcBtn = document.getElementById('satc-btn');
  if(satcBtn) {
    satcBtn.addEventListener('click', function() {
      var sel = document.querySelector('.satc-sz.on');
      if(!sel) { alert('Please select a size.'); return; }
      DCC.addToCart(sel.dataset.variantId, satcBtn);
    });
  }
};

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', function() {

  // Cart toggle
  var cartToggle = document.getElementById('cart-toggle');
  if(cartToggle) cartToggle.addEventListener('click', DCC.openCart);

  // Cart close
  var cartClose = document.getElementById('cart-close');
  if(cartClose) cartClose.addEventListener('click', DCC.closeCart);

  // Cart overlay
  var cartOverlay = document.getElementById('cart-overlay');
  if(cartOverlay) cartOverlay.addEventListener('click', DCC.closeCart);

  // Burger
  var burger = document.getElementById('burger-btn');
  if(burger) burger.addEventListener('click', DCC.toggleMobileNav);

  // Mobile nav close
  var mnClose = document.getElementById('mobile-nav-close');
  if(mnClose) mnClose.addEventListener('click', DCC.toggleMobileNav);

  // Search
  var searchToggle = document.getElementById('search-toggle');
  if(searchToggle) searchToggle.addEventListener('click', DCC.toggleSearch);

  var searchClose = document.getElementById('search-close');
  if(searchClose) searchClose.addEventListener('click', DCC.toggleSearch);

  // Escape key
  document.addEventListener('keydown', function(e) {
    if(e.key === 'Escape') {
      var so = document.getElementById('search-overlay');
      var mn = document.getElementById('mobile-nav');
      if(so) so.classList.remove('open');
      if(mn) mn.classList.remove('open');
      DCC.closeCart();
      document.body.style.overflow = '';
    }
  });

  // Quick-add cards
  document.querySelectorAll('.pcard-quick').forEach(function(quick) {
    quick.addEventListener('click', function(e) {
      e.preventDefault();
      var sel = this.querySelector('.sz.sel');
      if(!sel) {
        // Open product page instead
        var link = this.closest('.pcard').querySelector('a[href]');
        if(link) window.location.href = link.href;
        return;
      }
      DCC.addToCart(sel.dataset.variantId, null);
    });
  });

  // PDP size buttons
  document.querySelectorAll('.pdp-sz').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if(this.disabled) return;
      document.querySelectorAll('.pdp-sz').forEach(function(b){ b.classList.remove('sel'); });
      this.classList.add('sel');
      var vid = document.getElementById('pdp-variant-id');
      if(vid) vid.value = this.dataset.variantId;
      var priceEl = document.getElementById('pdp-price');
      var compareEl = document.getElementById('pdp-compare');
      if(priceEl && this.dataset.price) priceEl.textContent = this.dataset.price;
      if(compareEl) {
        if(this.dataset.compare && this.dataset.compare !== this.dataset.price) {
          compareEl.textContent = this.dataset.compare;
          compareEl.style.display = 'inline';
          if(priceEl) priceEl.classList.add('sale');
        } else {
          compareEl.style.display = 'none';
          if(priceEl) priceEl.classList.remove('sale');
        }
      }
      var atcBtn = document.getElementById('pdp-atc-btn');
      if(atcBtn) atcBtn.textContent = this.dataset.available === 'true' ? 'Add to Cart' : 'Sold Out';
      // Sync sticky
      var sz = this.dataset.size;
      document.querySelectorAll('.satc-sz').forEach(function(b){ b.classList.toggle('on', b.dataset.size === sz); });
    });
  });

  // Satc size buttons
  document.querySelectorAll('.satc-sz').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.satc-sz').forEach(function(b){ b.classList.remove('on'); });
      this.classList.add('on');
      var sz = this.dataset.size;
      document.querySelectorAll('.pdp-sz').forEach(function(b){
        if(b.dataset.size === sz) b.click();
      });
    });
  });

  // PDP form submit
  var pdpForm = document.getElementById('pdp-form');
  if(pdpForm) {
    pdpForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var vid = document.getElementById('pdp-variant-id');
      var btn = document.getElementById('pdp-atc-btn');
      if(vid && vid.value) DCC.addToCart(vid.value, btn);
    });
  }

  // Thumbnail swap
  document.querySelectorAll('.pdp-thumb[data-full]').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainPhoto = document.getElementById('pdp-main-photo');
      if(mainPhoto) mainPhoto.src = this.dataset.full;
      document.querySelectorAll('.pdp-thumb').forEach(function(t){ t.classList.remove('sel'); });
      this.classList.add('sel');
    });
  });

  // Collection filter chips
  document.querySelectorAll('.filter-bar .chip').forEach(function(chip) {
    chip.addEventListener('click', function() {
      this.closest('.filter-bar').querySelectorAll('.chip').forEach(function(c){ c.classList.remove('on'); });
      this.classList.add('on');
    });
  });

  // Sticky ATC
  DCC.initStickyAtc();

  // Update cart count
  DCC.Cart.get(function(cart) {
    var el = document.getElementById('cart-count');
    if(el) el.textContent = cart.item_count;
  });

});
